import { Injectable } from '@angular/core';
import { Observable, EMPTY } from 'rxjs';
import { parse } from 'postcode';
import { ApiService } from './api.service';

export interface PostcodeLookupResultAddress {
  building_name?: string;
  building_number?: string;
  sub_building_name?: string;
  thoroughfare?: string;
  town_or_city?: string;
  locality?: string;
  line_1?: string;
  line_2?: string;
  country?: string;
}

export interface PostcodeLookupResult {
  postcode: string;
  addresses: PostcodeLookupResultAddress[];
}

@Injectable({ providedIn: 'root' })
export class PostcodeLookupService {
  constructor(private apiService: ApiService) {}

  public lookup(postcode: string): Observable<PostcodeLookupResultAddress[]> {
    const parsedPostcode = parse(postcode);

    if (!parsedPostcode.valid) {
      return EMPTY;
    }

    return this.apiService.get<PostcodeLookupResultAddress[]>('address', 'lookup', {
      params: { postcode: parsedPostcode.postcode }
    });
  }
}
